import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import '@mgp-fe/shared/styles/index.scss';
import '@mgp-fe/shared/utils/font-awesome.ts';

ReactDOM.createRoot(document.getElementById('root')!)
	.render(<React.StrictMode>
		<App/>
	</React.StrictMode>); 